import {AfterContentChecked, Component, Injectable, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators, ValidationErrors, ValidatorFn, AsyncValidatorFn, AbstractControl} from '@node_modules/@angular/forms';
import {Subject} from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { UserValidators } from '../../../../user-validators';
import {ProgramService} from '@services/program/program.service';
import {Program} from '@models/program';
import {ErrorResponse} from '@interfaces/responses/error-response';
import {StudentService} from '@services/student/student.service';
import {CreateStudent} from '@interfaces/requests/create-student';
import {User} from '@models/user';
import {Store} from '@node_modules/@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';
import {AddUserToFamily} from '@store/auth/actions';
import {AuthService} from '@services/auth/auth.service';
import {ParentUsersService} from '@services/parentUsers/parent-users.service';
import {AccountServiceResponseInterface} from '@interfaces/accountServiceResponse.interface';
import {AccountService} from '@services/account/account.service';
import {Class} from '@models/class';
import {ClassService} from '@services/class/class.service';
import * as StudentReducer from '@store/student/reducers';
import {AddStudent, CloseModal} from '@store/student/actions';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {ProgramCreateComponent} from '@pages/layout/program/program-create/program-create.component';
import {MatDialog} from '@node_modules/@angular/material';
import {ActionTypes as ActionTypesProgram, SetPrograms} from '@store/program/actions';
import * as ProgramReducer from '@store/program/reducers';
import * as TeacherReducer from '@store/teacher/reducers';
import {AddTeacher} from '@store/teacher/actions';
import {SchoolService} from '@services/school/school.service';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {MessageService} from '@services/message/message.service';

@Component({
  selector: 'app-student-create.component',
  templateUrl: './student-create.component.html',
  styleUrls: ['./student-create.component.scss']
})

export class StudentCreateComponent implements OnInit, AfterContentChecked {
  static source = 'add_student';
  static currentProgramId: number;
  static fromScratch = false;
  static modalRef: any;
  static currentPrograms: Program[];
  static currentClassses: {[key: number]: Class[]} = {};
  mask$: Subject<string> = new BehaviorSubject(null);
  currentPhoneFormat;
  currentCountryCode;
  addMemberForm: FormGroup;
  programs: Program[];
  classes: {
    id: number,
    itemName: string
  }[] = [];
  user: User;
  newUser = false;
  tmpUser;
  source;
  noPrograms;
  loading = false;
  // dropdownSettings = {
  //   singleSelection: false,
  //   text:"Select Class",
  //   selectAllText:'Select All',
  //   unSelectAllText:'UnSelect All',
  //   enableSearchFilter: true,
  //   classes:"select-class"
  // };
  selectedItems = [];
  subscribes = [];
  createDialog;
  excludedRoles = ['student_individual', 'student_group'];
  confirmDeleteDialog;

  constructor(
    public dialog: MatDialog,
    private programService: ProgramService,
    private classService: ClassService,
    private schoolService: SchoolService,
    private studentService: StudentService,
    private accountService: AccountService,
    private parentUserService: ParentUsersService,
    private authService: AuthService,
    private authStore: Store<AuthReducer.AuthState>,
    private programStore: Store<ProgramReducer.ProgramState>,
    private studentStore: Store<StudentReducer.StudentState>,
    private teacherStore: Store<TeacherReducer.TeacherState>,
    private userValidators: UserValidators,
    private messageService: MessageService,
  ) {
    if (StudentCreateComponent.source) {
      this.source = StudentCreateComponent.source;
    }
  }

  ngOnInit() {
    // console.log(!this.isAddTeacher());
    if (StudentCreateComponent.source === 'add_teacher') {
      this.excludedRoles = ['teacher'];
    }

    this.authStore.subscribe(
      (val) => {
        const auth = val.auth;
        if (auth && auth.user) {
          this.user = auth.user;
        }
      }
    );
    this.programStore.subscribe(
      (val) => {
        if (val &&  val.program) {
          if (val.program.programs && (val.program.lastAction === 'SET_PROGRAMS' || val.program.lastAction === 'ADD_PROGRAM')) {
            this.programs = val.program.programs;
            this.noPrograms = this.programs.length === 0;
            // console.log(this.noPrograms)
          }
          if(this.createDialog &&  val.program.lastAction === ActionTypesProgram.ADD_PROGRAM) {
            this.createDialog.close();
          }
        }
      }
    );
    this.addMemberForm = new FormGroup({
      'program_id': new FormControl(''),
      'toTheCurrentSchool': new FormControl(this.isAddTeacher()),
      'class_id': new FormControl('' ),
      'first_name': new FormControl('', [Validators.required] ),
      'last_name': new FormControl('', [Validators.required]),
      'phone': new FormControl( ),
      'email': new FormControl('', [Validators.required, this.emailValidator.bind(this)]),
    }, {asyncValidators: this.userValidators.uniqueLoginValidator()});
    // console.log(this.addMemberForm);
    this.getPrograms();
    this.addMemberForm.valueChanges.subscribe(val => {
      this.addMemberForm.controls['program_id'].setErrors(null);
    });
  }
  ngAfterContentChecked() {
    // if (this.programs || this.programs.length === 0) {
    //   this.noPrograms = true;
    // }
  }

  showForm(event){
    console.log(this.addMemberForm);
  }
  emailValidator(control: FormControl) {
    let email = control.value;
    const schoolId = this.user.activeSchool;
    const re = /\S+@\S+\.\S+/;
    let response = null;
    if (!re.test(email)) {
      this.newUser = true;
      response = {email: true};
    } else {
      this.newUser = true;
      // this.accountService.findUserByEmail(schoolId, {
      //   email: email,
      // })
      //   .subscribe(
      //     (resp: {data: {status: number, user?: User}}) => {
      //       console.log(resp.data);
      //       const user = resp.data.user;
      //       if (resp.data.status === 200 && (user.avatar || user.name)) {
      //         user.avatar = user.avatar ? user.avatar : '../../../../../assets/noAvatar.png';
      //         if (user.email === this.user.email) {
      //           control.setErrors({apiValidate: 'You can\'t use own email address!'});
      //         } else if (user.role === 'teacher' && this.isAddStudent()) {
      //           control.setErrors({apiValidate: 'You can\'t invite teacher as student!'});
      //         } else if ((user.role === 'student_individual' || user.role === 'student_group') && this.isAddTeacher()) {
      //           control.setErrors({apiValidate: 'You can\'t invite student as teacher!'});
      //         } else if ((user.role === 'admin')) {
      //           control.setErrors({apiValidate: 'You can\'t invite admin!'});
      //         } else if (user.registerNotComplete === true) {
      //           control.setErrors({apiValidate: 'You can\'t invite member, which didn\'t finish registration!'});
      //         } else {
      //           this.newUser = false;
      //           this.tmpUser = {avatar: user.avatar, name: user.name, first_name: user.first_name,  last_name: user.last_name, id: user.id};
      //           this.addMemberForm.get('first_name').setValue(user.first_name);
      //           this.addMemberForm.get('last_name').setValue(user.last_name);
      //         }
      //       } else if (resp.data.status === 16200) {
      //         this.newUser = true;
      //       } else if (resp.data.status === 17200) {
      //         this.newUser = false;
      //         control.setErrors({apiValidate: 'You can\'t invite student from different school!'});
      //       }
      //       // console.log(email);
      //     },
      //     err => console.log(err),
      //   );
    }
    // console.log(response);
    return response;
  }

  openCreateProgram() {
    this.studentStore.dispatch(new CloseModal());
    ProgramCreateComponent.program = null;
    ProgramCreateComponent.editedItem = null;
    ProgramCreateComponent.sourceSchedule = null;
    ProgramCreateComponent.source = 'program';
    this.createDialog = this.dialog.open(ProgramCreateComponent);
    this.createDialog.afterClosed().subscribe(result => {
      this.createDialog.close();
    });
  }

  getPrograms() {
    if (!this.isAddFamilyMember()) {
      if (StudentCreateComponent.currentPrograms && StudentCreateComponent.currentPrograms.length > 0) {
          this.programStore.dispatch(new SetPrograms(StudentCreateComponent.currentPrograms));
          if (StudentCreateComponent.currentProgramId) {
            StudentCreateComponent.currentPrograms.map(program => {
              if (program.id === StudentCreateComponent.currentProgramId) {
                this.addMemberForm.get('program_id').setValue(program.id);
                this.onProgramSelected(program.id);
              }
            });
          }
      } else {
        this.programService.getAll().subscribe(
          (resp: { data: Program[] }) => {
            // this.programs = resp.data;
            this.programStore.dispatch(new SetPrograms(resp.data));
            if (resp.data.length > 0) {
              this.addMemberForm.get('program_id').setValue(resp.data[0].id);
              this.onProgramSelected(resp.data[0].id);
            } else {
              this.noPrograms = true;
            }
          },
          (err: ErrorResponse) => {
            console.log(err);
            Object.keys(err.error.errors).map(item => {
              if (item !== 'avatar') {
                this.addMemberForm.controls[item].setErrors({'apiValidate': err.error.errors[item]});
              }
            });
          });
      }
    } else if (StudentCreateComponent.currentProgramId && this.isAddFamilyMember()) {
      if (!StudentCreateComponent.currentPrograms) {
        this.programService.getSchoolPrograms(StudentCreateComponent.currentProgramId).subscribe(
          (resp: {data: Program[]}) => {
            // this.programs = resp.data;
            this.programStore.dispatch(new SetPrograms(resp.data));
            StudentCreateComponent.currentPrograms = resp.data;
            if (this.programs.length > 0) {
              this.addMemberForm.get('program_id').setValue(this.programs[0].id);
              this.onProgramSelected(this.programs[0].id);
            }
          },
          (err: ErrorResponse) => {
            console.log(err);
            Object.keys(err.error.errors).map(item => {
              if (item !== 'avatar') {
                this.addMemberForm.controls[item].setErrors({'apiValidate': err.error.errors[item]});
              }
            });
          }
        );
      } else {
        this.programStore.dispatch(new SetPrograms(StudentCreateComponent.currentPrograms));
        this.addMemberForm.get('program_id').setValue(this.programs[0].id);
        this.onProgramSelected(this.programs[0].id);
      }
    }
  }

  onPhoneError(event) {
    this.addMemberForm.get('phone').setErrors({'range': true});
  }

  onCountrychange(event) {
    this.currentCountryCode = event.countryData.dialCode;
    this.currentPhoneFormat = event.placeholder;
    this.mask$.next(event.mask.replace(/[0-9]/g, "0"));
  }

  async onAddMember() {
    this.loading = true;
    const roleName = this.isAddStudent() ? 'student_individual' : 'teacher';
    const student: CreateStudent = {
      role_name: roleName,
      first_name: this.addMemberForm.get('first_name').value,
      last_name: this.addMemberForm.get('last_name').value,
      email: this.addMemberForm.get('email').value,
      phone: '+' + this.currentCountryCode + this.addMemberForm.get('phone').value,
      program_id: this.addMemberForm.get('program_id').value,
      parent_id: this.isAddFamilyMember() ? this.user.id : null,
    };
    this.studentService.create(student)
      .subscribe(
        async (resp: {data: User}) => {
          const child = resp.data;
          console.log(resp, 'resp');
          console.log(this.isAddFamilyMember(), 'this.isAddFamilyMember()');
          console.log(this.newUser, 'this.newUser');
          if (this.isAddFamilyMember()) {
            if (Number(child.parent_id) === Number(this.user.id)) {
              this.authStore.dispatch(new AddUserToFamily({user: child}));
            } else {
              this.addUserToFAmily(this.user.id, child.id);
            }
          } else {
            if (this.newUser) {
              if (this.addMemberForm.get('toTheCurrentSchool').value) {
                await this.addUserToSchool(child.id);
              } else {
                await this.addUserToProgram(child.id);
              }
              this.loading = false;
            }  else {
              this.inviteUserToProgram(child.id);
            }
          }
          if (StudentCreateComponent.modalRef) {
            StudentCreateComponent.modalRef.close();
          }
        }, err => {
          console.log(err);
        }
      );
  }

  inviteUserToProgram(user_id) {
    // let classes = [];
    // if (!this.isFromScratch()) {
    //   this.addMemberForm.get('class_id').value.map(item => {
    //     classes.push(item.id);
    //   });
    // }
    this.programService.inviteUser({
      user_id: user_id,
      program_id: this.addMemberForm.get('program_id').value,
      // classc_id: classes
    })
      .subscribe(
        (resp: {data: User}) => {
          this.loading = false;
          this.studentStore.dispatch(new CloseModal());
          if (resp.data.id) {
            if (StudentCreateComponent.source === 'add_student') {
              this.studentStore.dispatch(new AddStudent(resp.data));
            }
            if (StudentCreateComponent.source === 'add_teacher') {
              // this.teacherStore.dispatch(new AddTeacher(resp.data));
            }
          }
          if (StudentCreateComponent.modalRef) {
            StudentCreateComponent.modalRef.close();
          }
        },
        (err: ErrorResponse) => {
          this.loading = false;
          console.log(err);
          Object.keys(err.error.errors).map(item => {
            console.log(item);
            if (item !== 'avatar') {
              this.addMemberForm.controls[item].setErrors({'apiValidate': err.error.errors[item]});
            }
          });
          // console.log(this.addMemberForm);
        }
      );
  }

  inviteUserToSchool(user_id) {
    this.schoolService.inviteUserToSchool({
      user_id: user_id,
    })
      .subscribe(
        (resp: {data: User}) => {
          this.loading = false;
          this.studentStore.dispatch(new CloseModal());
          if (resp.data.id) {
            // console.log(StudentCreateComponent.source);
            if (StudentCreateComponent.source === 'add_student') {
              this.studentStore.dispatch(new AddStudent(resp.data));
            }
            if (StudentCreateComponent.source === 'add_teacher') {
              // this.teacherStore.dispatch(new AddTeacher(resp.data));
            }          }
          if (StudentCreateComponent.modalRef) {
            StudentCreateComponent.modalRef.close();
          }
        },
        (err: ErrorResponse) => {
          console.log(err);
          Object.keys(err.error.errors).map(item => {
            if (item !== 'avatar') {
              this.addMemberForm.controls[item].setErrors({'apiValidate': err.error.errors[item]});
            }
          });
          // console.log(this.addMemberForm);
        }
      );
  }

  async addUserToSchool(user_id: number) {
    return new Promise( resolve => this.schoolService.addUserToSchool({
      user_id: user_id,
    })
      .subscribe(
        async (resp: {data: User}) => {
          this.messageService.sendNewUserMessage({
            schoolId: this.user.activeSchool,
            userId: user_id
          }).subscribe();
          await this.studentStore.dispatch(new CloseModal());
          if (resp.data.id) {
            // console.log(StudentCreateComponent.source);
            if (StudentCreateComponent.source === 'add_student') {
              this.studentStore.dispatch(new AddStudent(resp.data));
            }
            if (StudentCreateComponent.source === 'add_teacher') {
              // this.teacherStore.dispatch(new AddTeacher(resp.data));
            }
          }
          if (StudentCreateComponent.modalRef) {
            StudentCreateComponent.modalRef.close();
          }
          resolve(true);
        },
        (err: ErrorResponse) => {
          console.log(err);
          Object.keys(err.error.errors).map(item => {
            if (item !== 'avatar') {
              this.addMemberForm.controls[item].setErrors({'apiValidate': err.error.errors[item]});
            }
          });
          // console.log(this.addMemberForm);
          resolve(false);
        }
      )
    );
  }

  addUserToProgram(user_id) {
    // let classes = [];
    // if (!this.isFromScratch()) {
    //   this.addMemberForm.get('class_id').value.map(item => {
    //     classes.push(item.id);
    //   });
    // }
    return new Promise( resolve => this.programService.addUser({
      user_id: user_id,
      program_id: this.addMemberForm.get('program_id').value,
      // classc_id: classes,
    })
      .subscribe(
        async (resp: {data: User}) => {
          await this.messageService.sendNewUserMessage({
            schoolId: this.user.activeSchool,
            programId: this.addMemberForm.get('program_id').value,
            userId: user_id
          }).subscribe();
          this.studentStore.dispatch(new CloseModal());
          // console.log(StudentCreateComponent.source);
          if (resp.data.id) {
            if (StudentCreateComponent.source === 'add_student') {
              this.studentStore.dispatch(new AddStudent(resp.data));
            }
            if (StudentCreateComponent.source === 'add_teacher') {
              // this.teacherStore.dispatch(new AddTeacher(resp.data));
            }
          }
          resolve(true);
        },
        err => {
          console.log(err);
          this.studentStore.dispatch(new CloseModal());
          resolve(false);
        }
      )
    );
  }
  addUserToFAmily(parent_id, child_id) {
    this.parentUserService.addUserToFamily(parent_id, this.user.activeSchool, child_id)
      .subscribe(
        (resp2: AccountServiceResponseInterface) => {
          this.loading = false;
          const child = resp2.data;
          // console.log(resp2);
          this.authStore.dispatch(new AddUserToFamily({user: child}));
          if (StudentCreateComponent.modalRef) {
            StudentCreateComponent.modalRef.close();
          }
        },
        err => console.log(err)
      );
  }
  onInviteMember() {
    this.loading = true;
    if (this.isAddFamilyMember()) {
      this.addUserToFAmily(this.user.id, this.tmpUser.id);
    } else if (this.addMemberForm.get('toTheCurrentSchool').value || this.addMemberForm.get('program_id').value.length === 0) {
      this.inviteUserToSchool(this.tmpUser.id);
    } else {
      this.inviteUserToProgram(this.tmpUser.id);
    }
  }
  onProgramSelected(id) {
    this.selectedItems = [];
    this.deleteThreePoints();
    this.classes = [];
    // this.programs.map( program => {
    //   if (program.id = id) {
    //     program.classes.map( item => {
    //       this.classes.push({
    //         id: item.id,
    //         itemName: item.name
    //       })
    //     });
    //   }
    // });
    // if (!StudentCreateComponent.currentClassses[id]) {
    //   this.classService.getAllProgramsClasses(this.addMemberForm.get('program_id').value).subscribe(
    //     (resp: { data: Class[] }) => {
    //       console.log(resp);
    //       StudentCreateComponent.currentClassses[id] = resp.data;
    //       resp.data.map(item => {
    //         this.classes.push({
    //           id: item.id,
    //           itemName: item.name
    //         });
    //       });
    //     }
    //   );
    // } else {
    //   StudentCreateComponent.currentClassses[id].map(item => {
    //     this.classes.push({
    //       id: item.id,
    //       itemName: item.name
    //     });
    //   });
    // }
  }
  isAddStudent() {
    return StudentCreateComponent.source === 'add_student';
  }
  isAddFamilyMember() {
    return StudentCreateComponent.source === 'add_family_member';
  }
  isAddTeacher() {
    return StudentCreateComponent.source === 'add_teacher';
  }
  onItemSelect(event) {
    if (this.selectedItems.length > 2) {
      setTimeout(() => {
        let selectedList = document.getElementsByClassName('c-list');
        if (selectedList) {
          // console.log(selectedList.item(0));
          // console.log(selectedList.item(1));
          let span = document.createElement('span');
          span.innerText = '...';
          span.classList.add('threePoints');
          selectedList.item(0).appendChild(span);
        }
      }, 50);
    } else {
      this.deleteThreePoints();
    }
    // console.log(this.addMemberForm);
  }
  deleteThreePoints() {
    let elements = document.getElementsByClassName('threePoints');
    while(elements.length > 0){
      elements[0].parentNode.removeChild(elements[0]);
    }
  }
  isFromScratch() {
    return StudentCreateComponent.fromScratch;
  }
  close() {
    if (this.addMemberForm.get('email').value && this.addMemberForm.get('email').value.length > 0 ||
      this.addMemberForm.get('phone').value && this.addMemberForm.get('phone').value.length > 0 ||
      this.addMemberForm.get('first_name').value && this.addMemberForm.get('first_name').value.length > 0 ||
      this.addMemberForm.get('last_name').value && this.addMemberForm.get('last_name').value.length > 0) {
      ConfirmModalComponent.insertedObject = this;
      ConfirmModalComponent.methodDelete = 'closeAction';
      ConfirmModalComponent.textModal = 'Close Modal?';
      ConfirmModalComponent.textButton = 'Close';
      this.confirmDeleteDialog = this.dialog.open(ConfirmModalComponent);
      ConfirmModalComponent.modalRef = this.confirmDeleteDialog;
    } else if (StudentCreateComponent.modalRef) {
      this.closeAction();
    }
  }
  closeAction() {
    StudentCreateComponent.modalRef.close();
  }
}
